<template>
  <div>
    <b-modal id="smsEditor" size="lg" @hidden="clearData">
      <div slot="modal-header">
        <h2>{{ $t("edit_campaign.sms_template_edit_content_modal", "Custom SMS content") }}</h2>
      </div>

      <div slot="modal-footer">
        <button class="bttn bttn--lg bttn--blue" @click.prevent="hideModal">
          {{ $t("dashboard.integration_export_close") }}
        </button>

        <button
          :disabled="smsMarkup === template?.attributes?.message"
          class="bttn bttn--lg bttn--orange tw-ms-auto rtl:!tw-ml-0"
          @click="saveEmailTemplate"
        >
          {{ $t("dashboard.email_template_save") }}
        </button>
      </div>
      <div>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-mb-8">
          <p class="tw-mb-2 tw-font-bold rtl:tw-text-right">
            {{
              $t(
                "dashboard.sms_template_variables_title",
                "Variables you can use in the sms content"
              )
            }}
          </p>
          <p
            v-for="variable in variables"
            :key="variable.name"
            class="tw-flex tw-items-center tw-gap-2"
          >
            <span
              v-html="variable.name"
              class="tw-bg-[rgba(136,186,204,0.4)] tw-border-[1px] tw-border-[#2883a2] tw-rounded-[3px] tw-px-[10px] tw-py-[5px] tw-text-[14px] tw-align-self-flex-start tw-cursor-pointer hover:tw-bg-[rgba(136,186,204,0.6)]"
              @click="insertVariable(variable.name)"
            />
            {{ variable.label }}
          </p>
        </div>

        <textarea
          ref="smsTextarea"
          v-model="smsMarkup"
          rows="10"
          class="tw-w-full tw-border-[1px] tw-border-[#ccc] tw-px-[15px] tw-py-[12px] tw-outline-none"
          @click="updateCursorPosition"
          @keyup="updateCursorPosition"
          @focus="updateCursorPosition"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      smsMarkup: "",
      cursorPosition: 0,
      template: null,
    };
  },

  computed: {
    isPublicNewTeamCreated() {
      return this.template?.attributes.title === "publicnewteamcreated";
    },

    isTeamDonationNotification() {
      return this.template?.attributes.title === "team_donation_notification";
    },

    variables() {
      if (this.isPublicNewTeamCreated) {
        return [
          {
            name: "[LEADER_NAME]",
            label: this.$t("dashboard.sms_template_variables_leader_name", "Team leader Name"),
          },
          {
            name: "[CAMPAIGN_TITLE]",
            label: this.$t("dashboard.sms_template_variables_campaign_title", "Campaign title"),
          },
          {
            name: "[TEAM_FULL_LINK]",
            label: this.$t("dashboard.sms_template_variables_team_fulllink", "Team full link"),
          },
          {
            name: "[SHORTLINK]",
            label: this.$t("dashboard.sms_template_variables_shortlink", "Shortlink"),
          },
        ];
      }

      if (this.isTeamDonationNotification) {
        return [
          {
            name: "{{ .DonationList }}",
            label: this.$t("dashboard.email_template_variables_donation_list", "List of donations"),
          },
          {
            name: "{{ .DonationListCount }}",
            label: this.$t(
              "dashboard.email_template_variables_donation_list_count",
              "List of donations count"
            ),
          },
          {
            name: "{{ .Multiple }}",
            label: this.$t("dashboard.email_template_variables_multiple", "Multiple"),
          },
          {
            name: "{{ .DateNow }}",
            label: this.$t("dashboard.email_template_variables_date_now", "Date now"),
          },
        ];
      }

      return [];
    },
  },

  methods: {
    saveEmailTemplate() {
      this.template.attributes.message = this.smsMarkup;
      this.$emit("save-sms-template", this.template);
    },

    updateCursorPosition() {
      this.$nextTick(() => {
        if (this.$refs.smsTextarea) {
          this.cursorPosition = this.$refs.smsTextarea.selectionStart;
        }
      });
    },

    insertVariable(variable) {
      const textarea = this.$refs.smsTextarea;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const before = textarea.value.substring(0, start);
      const after = textarea.value.substring(end);

      textarea.value = before + variable + after;

      const newPosition = start + variable.length;
      textarea.focus();
      textarea.setSelectionRange(newPosition, newPosition);

      this.smsMarkup = textarea.value;
      this.cursorPosition = newPosition;
    },

    clearData() {
      this.cursorPosition = 0;
      this.smsMarkup = "";
      this.template = null;
    },

    openModal(template) {
      this.template = template;
      this.smsMarkup = template.attributes?.message;
      this.$root.$emit("bv::show::modal", "smsEditor");
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "smsEditor");
    },
  },
});
</script>

<style lang="scss" scoped></style>
